// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"4ef7afd0","263":"6c14fcbd"}[chunkId] + ".chunk.css";
};